import { render, staticRenderFns } from "./AntFamiliaresTable.vue?vue&type=template&id=2a9e9742"
import script from "./AntFamiliaresTable.vue?vue&type=script&lang=js"
export * from "./AntFamiliaresTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports